import { LegendWebElementBase } from './LegendWebElementBase';

/**
 * The component WebElement for [oj-c-legend](../../jsdocs/oj-c.Legend.html).
 * Do not instantiate this class directly, instead, use
 * [findLegend](../functions/findLegend.html).
 */
export class LegendWebElement extends LegendWebElementBase {
  // Put overrides here
}
